/**
 * Configuration for the NgwWowService service.
 */
export var NgwWowConfig = (function () {
    function NgwWowConfig() {
        /**
         * Class name that reveals the hidden box when user scrolls.
         */
        this.boxClass = 'wow';
        /**
         * Class name that triggers the CSS animations ('animated' by default for the animate.css library)
         */
        this.animateClass = 'animated';
        /**
         * Define the distance between the bottom of browser viewport and the top of hidden box.
         * When the user scrolls and reach this distance the hidden box is revealed.
         */
        this.offset = 0;
        /**
         * Turn on/off WOW.js on mobile devices.
         */
        this.mobile = true;
        /**
         * Consatantly check for new WOW elements on the page.
         */
        this.live = true;
    }
    return NgwWowConfig;
}());
//# sourceMappingURL=wow-config.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-wow/models/wow-config.js
// module id = ./node_modules/ngx-wow/models/wow-config.js
// module chunks = vendor